import React, {useState} from 'react';


const Sidebar = () => {
    return (
        <div
            className="bg-login-light h-full h-md-fit d-flex flex-column justify-content-around align-items-center p-5">
            {/* **************** TITLE TEXT **************** */}
            <div className="text-center">
                <a href="">
                    <img src={"./assets/logo.png"} alt="logo" className="h-80px logo mb-5"/>
                </a>
                <h1 className="fw-bolder f-3 py-3 mt-3">به پنل زمین هاست خوش آمدید ...</h1>
                <h2 className="f-12 pb-2">با بیش از یک دهه پشتیبانی و ارائه خدمات میزبانی</h2>
                <a className="nav-link custom-nav-link d-flex justify-content-center align-items-center"
                   href="tel:02191307989"><span className="f-12 text-dark">۰۲۱۹۱۳۰۷۹۸۹</span><i
                    className="bi bi-telephone f-15 text-dark ms-2"></i></a>
            </div>
            {/* **************** TITLE IMAGE **************** */}
            <div>
                <img src={"./assets/media/illustrations/Data_security_28.jpg"} alt="about_us"
                     className="login-image d-none d-md-block"/>
            </div>
        </div>
    )
}

export default Sidebar;
